jQuery(document).ready(function ($) {

    var module_name = 'bookmaker_info';
});